import React from 'react';
import { LayoutGroup, motion } from 'motion/react';
import { SPRING_PILL } from '../../motion/tokens';
import usePrefersReducedMotion from '../../motion/usePrefersReducedMotion';

export default function PillTabs({
  value,
  onChange,
  options,
  disabled = false,
  layoutId = 'pill-tabs',
  className = '',
  size = 'md',
  fullWidth = false,
}) {
  const reduced = usePrefersReducedMotion();
  const sizeClass =
    size === 'sm'
      ? 'px-2.5 py-1.5 text-xs'
      : size === 'lg'
        ? 'px-4 py-3 text-sm sm:text-base'
        : 'px-3 py-2.5 text-sm';

  return (
    <LayoutGroup id={layoutId}>
      <div
        className={`flex flex-wrap gap-1 rounded-xl bg-gray-100 p-1 ${
          fullWidth ? 'w-full' : ''
        } ${className}`.trim()}
        role="tablist"
      >
        {options.map((option) => {
          const id = option.id;
          const active = value === id;
          const Icon = option.icon;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={active}
              aria-label={option.label || option.id}
              disabled={disabled || option.disabled}
              onClick={() => {
                option.onBeforeSelect?.();
                onChange(id);
              }}
              className={`relative inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors duration-150 active:scale-[0.97] disabled:opacity-50 ${sizeClass} ${
                fullWidth ? 'min-w-[7rem] flex-1' : ''
              } ${active ? 'text-teal-800' : 'text-gray-500 hover:text-gray-700'}`}
            >
              {active && !reduced && (
                <motion.span
                  layoutId={`${layoutId}-indicator`}
                  className="absolute inset-0 rounded-lg bg-white shadow-sm"
                  transition={SPRING_PILL}
                />
              )}
              {active && reduced && (
                <span className="absolute inset-0 rounded-lg bg-white shadow-sm" />
              )}
              <span className="relative z-[1] inline-flex items-center gap-2">
                {Icon ? <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden="true" /> : null}
                {option.label ? <span>{option.label}</span> : null}
                {option.count != null && option.count !== '' && (
                  <span
                    className={`rounded-full px-1.5 py-0.5 text-[10px] font-bold tabular-nums ${
                      active ? 'bg-teal-100 text-teal-800' : 'bg-gray-200 text-gray-600'
                    }`}
                  >
                    {option.count}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </LayoutGroup>
  );
}
